import React from "react";
import Title from "../layouts/Title";
import { projectOne, projectTwo, projectThree } from "../../assets/index";
import ProjectsCard from "./ProjectsCard";

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title des="My Projects" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          link="https://github.com/CSC4790-Fall2025-Org/senior-project-pokerreview"
          title="Poker Review"
          des="I developed a poker review platform where users can play Texas Hold'em with friends and receive AI-powered analysis to improve their gameplay. The platform features real-time multiplayer functionality with comprehensive game state tracking, logging every action including bets, raises, checks, and folds throughout each hand. I integrated the OpenAI API to provide intelligent move suggestions during play and detailed post-game reviews that highlight mistakes, optimal strategies, and areas for improvement. The platform stores complete hand histories to track player progress over time and deliver personalized coaching insights."
          src={projectOne}
          techStack={[
            "React",
            "TypeScript",
            "Node.js",
            "PostgreSQL",
            "Socket.io",
            "OpenAI API",
            "Tailwind CSS",
          ]}
        />
        <ProjectsCard
          link="https://github.com/Fatih-Illeez/foodVendorProject"
          title="Food Delivery Website"
          des="I developed a food ordering platform inspired by DoorDash, featuring dual registration for customers and vendors with secure email verification. The platform includes a marketplace where vendors can list their offerings, and customers can browse and make purchases seamlessly. To enhance functionality, I integrated the PayPal API for secure transactions and the Google Maps API for location-based services, ensuring a smooth and efficient user experience."
          src={projectTwo}
          techStack={[
            "Python",
            "Django",
            "PostgreSQL",
            "JavaScript",
            "Google Maps API",
            "PayPal API",
          ]}
        />
        <ProjectsCard
          link="https://github.com/Software-Development-Society/roommate-matcher"
          title="Roommate Matcher"
          des="As a member of the Software Development team at Villanova University, I worked together with a team of 7 developers to create a successful roommate matching website for Villanova University. The platform features secure user authentication, reliable data handling, and a smart matching algorithm to connect users effectively. My work improved the site's performance and provided a seamless experience for students looking for compatible roommates."
          src={projectThree}
          techStack={[
            "Java",
            "JavaScript",
            "MongoDB",
            "React",
            "EJS",
            "Bootstrap",
          ]}
        />
      </div>
    </section>
  );
};

export default Projects;
